export default __webpack_public_path__ + "static/media/pic9-1.91344d48.jpg";